export const transformFormFields = (formData) => {

  const result = {
    preferences: {
      targetAllocation: {
        equity: formData.targetAllocation,
        fixed: 100 - formData.targetAllocation,
      },
      useGlobalCore: formData.useGlobal,
      includeGold: formData.includeGold,
      includeBitcoin: formData.includeBitcoin,
      incomeFocusStrength: formData.incomeFocus,
      leanPortfolio: transformInvestmentStyle(formData.leanPortfolio),
      maxExposures: formData.maxExposures,
    },
    info: {
      ...formData.info,
    }
  };

  return result;
};

// Helper functions for transformations
export const transformInvestmentStyle = (leanValue) => {
  const styles = {
    '-2': 'leanHeavyValue',
    '-1': 'leanModerateValue',
    '0': 'equalValueAndGrowth',
    '1': 'leanModerateGrowth',
    '2': 'leanHeavyGrowth',
  };
  return styles[leanValue] || 'neutral';
};

export const transformSimulationData = (seriesData)=>{
    const timestamps = seriesData.map(x=>x.timestamp);
    const highValues = seriesData.map(x=>x.high);
    const medianValues = seriesData.map(x=>x.value);
    const lowValues = seriesData.map(x=>x.low);

    const chartData = [
        {
            plot: 0,
            data: [
                {
                    name: "Upper Confidence",
                    data: timestamps.map((x, i)=>[x, highValues[i]]),
                    stroke: "#5bcbff",
                    dotted: true
                },
                {
                    name: "Median",
                    data: timestamps.map((x, i)=>[x, medianValues[i]]),
                    thickness: 2
                },
                {
                    name: "Lower Confidence",
                    data: timestamps.map((x, i)=>[x, lowValues[i]]),
                    stroke: '#f55982',
                    dotted: true
                }
            ]
        }
    ];
    return chartData
}
